var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { PublishStateModel } from './publish.state.model';
import { SetPublishDimensions, GetPublishURL, GetPublishIFrame, GetPublishURLSuccess, GetPublishIFrameSuccess, GetPublishURLFail, GetPublishIFrameFail, SetPublishWidgetURL, SetPublishing, ResetPublish, GetPublishImageCode, GetPublishImageCodeSuccess, GetPublishImageCodeFail, SavePublishImage, SavePublishImageFail, SavePublishImageSuccess } from './publish.actions';
import { PublishService, PublishLinkType } from '../publish.service';
import { defaultScreen } from '../data/screens';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { forkJoin } from 'rxjs';
var defaultWidgetURL = '/viewer';
var initialState = {
    publishing: false,
    widgetURL: defaultWidgetURL,
    dimensions: defaultScreen.dimensions,
    minDimensions: {
        width: 300,
        height: 400
    }
};
var PublishState = /** @class */ (function () {
    function PublishState(publishService, store) {
        this.publishService = publishService;
        this.store = store;
    }
    PublishState.getDimensions = function (state) {
        return state.dimensions;
    };
    PublishState.getMinDimensions = function (state) {
        return state.minDimensions;
    };
    PublishState.getWidgetURL = function (state) {
        return state.widgetURL;
    };
    PublishState.getPublishing = function (state) {
        return state.publishing;
    };
    PublishState.prototype.setPublishWidgetURL = function (context, action) {
        context.patchState({
            widgetURL: action.widgetURL || defaultWidgetURL
        });
    };
    PublishState.prototype.setPublishDimensions = function (context, action) {
        context.patchState({
            dimensions: action.dimensions
        });
    };
    PublishState.prototype.getPublishURL = function (context, action) {
        var model = action.model, camera = action.camera, widgetOptions = action.widgetOptions;
        var widgetURL = context.getState().widgetURL;
        var lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        var app = this.store.selectSnapshot(AuthState.getSelectedUserApp);
        // get url
        this.publishService.generateWidgetURL(model, widgetURL, widgetOptions, camera, PublishLinkType.Single, lang, app)
            .subscribe(function (url) {
            context.dispatch(new GetPublishURLSuccess(model, url));
        }, function () {
            context.dispatch(new GetPublishURLFail(model));
        });
    };
    PublishState.prototype.getPublishIFrame = function (context, action) {
        var model = action.model, camera = action.camera, widgetOptions = action.widgetOptions;
        var _a = context.getState(), widgetURL = _a.widgetURL, dimensions = _a.dimensions;
        var lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        var app = this.store.selectSnapshot(AuthState.getSelectedUserApp);
        // get embed code
        this.publishService.generateWidgetEmbed(model, widgetURL, widgetOptions, dimensions, camera, PublishLinkType.Single, lang, app)
            .subscribe(function (embedCode) {
            context.dispatch(new GetPublishIFrameSuccess(embedCode));
        }, function () {
            context.dispatch(new GetPublishIFrameFail());
        });
    };
    PublishState.prototype.savePublishImage = function (context, _a) {
        var imageData = _a.imageData;
        this.publishService.saveUserImage(imageData)
            .subscribe(function (imageURL) {
            context.dispatch(new SavePublishImageSuccess(imageURL));
        }, function () {
            context.dispatch(new SavePublishImageFail());
        });
    };
    PublishState.prototype.getPublishImage = function (context, action) {
        var _this = this;
        var model = action.model, camera = action.camera, widgetOptions = action.widgetOptions, imageData = action.imageData;
        var widgetURL = context.getState().widgetURL;
        var lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        var app = this.store.selectSnapshot(AuthState.getSelectedUserApp);
        forkJoin(this.publishService.generateWidgetURL(model, widgetURL, widgetOptions, camera, PublishLinkType.Single, lang, app), // generate widget url
        this.publishService.saveUserImage(imageData) // generate image url      
        )
            .subscribe(function (_a) {
            var _b = __read(_a, 2), generatedWidgeURL = _b[0], generatedImageURL = _b[1];
            var embed = _this.publishService.getImageEmbed(model.title, generatedWidgeURL, generatedImageURL);
            context.dispatch(new GetPublishImageCodeSuccess(embed));
        }, function () {
            context.dispatch(new GetPublishImageCodeFail());
        });
    };
    PublishState.prototype.setPublishing = function (context, _a) {
        var publishing = _a.publishing;
        context.patchState({
            publishing: publishing
        });
    };
    PublishState.prototype.resetPublish = function (context, action) {
        context.setState(initialState);
    };
    __decorate([
        Action(SetPublishWidgetURL),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetPublishWidgetURL]),
        __metadata("design:returntype", void 0)
    ], PublishState.prototype, "setPublishWidgetURL", null);
    __decorate([
        Action(SetPublishDimensions),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetPublishDimensions]),
        __metadata("design:returntype", void 0)
    ], PublishState.prototype, "setPublishDimensions", null);
    __decorate([
        Action(GetPublishURL),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetPublishURL]),
        __metadata("design:returntype", void 0)
    ], PublishState.prototype, "getPublishURL", null);
    __decorate([
        Action(GetPublishIFrame),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetPublishIFrame]),
        __metadata("design:returntype", void 0)
    ], PublishState.prototype, "getPublishIFrame", null);
    __decorate([
        Action(SavePublishImage),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SavePublishImage]),
        __metadata("design:returntype", void 0)
    ], PublishState.prototype, "savePublishImage", null);
    __decorate([
        Action(GetPublishImageCode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetPublishImageCode]),
        __metadata("design:returntype", void 0)
    ], PublishState.prototype, "getPublishImage", null);
    __decorate([
        Action(SetPublishing),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetPublishing]),
        __metadata("design:returntype", void 0)
    ], PublishState.prototype, "setPublishing", null);
    __decorate([
        Action(ResetPublish),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetPublish]),
        __metadata("design:returntype", void 0)
    ], PublishState.prototype, "resetPublish", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [PublishStateModel]),
        __metadata("design:returntype", void 0)
    ], PublishState, "getDimensions", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [PublishStateModel]),
        __metadata("design:returntype", void 0)
    ], PublishState, "getMinDimensions", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [PublishStateModel]),
        __metadata("design:returntype", void 0)
    ], PublishState, "getWidgetURL", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [PublishStateModel]),
        __metadata("design:returntype", void 0)
    ], PublishState, "getPublishing", null);
    PublishState = __decorate([
        State({
            name: 'publish',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [PublishService,
            Store])
    ], PublishState);
    return PublishState;
}());
export { PublishState };
